import React from 'react'

import { Modal, Switch } from 'antd'
import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'

import AlertIcon from '../../../assets/images/ico_erro.svg'
import LixeiraIcon from '../../../assets/images/lixeira.svg'
import DataTable from '../../../components/DataTable/DataTable'
import { getMessage } from '../../../util/IntlMessages'
import { validateCanEditWalletByRange } from '../utils'
import { api, request } from '../../../util/handlerRequestUtil'

const { confirm } = Modal

const filters = {
  global: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS
  },
  customer: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS
  },
  location: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS
  },
  category: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS
  },
  areaTotal: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS
  }
}

const List = ({ state, setState, customersList, ref, removeLocationFromWallet, memberId, districtId }) => {
  function showConfirmRemove(regionLinksIds) {
    const startDate = state.configuration.clientEditionPeriodStartDate
    const endDate = state.configuration.clientEditionPeriodEndDate
    if (!validateCanEditWalletByRange(startDate, endDate, true)) {
      return
    }

    let removeWarningMessage =
      'Todos os agricultores selecionados serão removidos de sua carteira. Você deseja continuar?'
    if (regionLinksIds.length === 1) {
      const customer = state.customerList.find(
        (currentCustomer) => currentCustomer.customerLinkId === regionLinksIds[0]
      )

      if (customer) {
        const customerName = customer.customer
        removeWarningMessage = `O agricultor "${customerName}" será removido de sua carteira. Você deseja continuar?`
      }
    }

    confirm({
      title: <img src={AlertIcon} alt="" style={{ marginLeft: '42%' }} />,
      icon: null,
      content: removeWarningMessage,
      okText: getMessage('label.yes'),
      cancelText: getMessage('label.no'),
      okButtonProps: {
        type: 'default'
      },
      cancelButtonProps: {
        type: 'default'
      },
      onOk() {
        removeLocationFromWallet(regionLinksIds)
      },
      onCancel: () => {}
    })
  }

  const editBodyTemplate = ({ key }) => (
    <Button
      className="p-button-text"
      style={{ border: 'none' }}
      onClick={() => {
        showConfirmRemove([key])
      }}
    >
      <img src={LixeiraIcon} alt="Remover" width={24} />
    </Button>
  )

  const updateCustomerFocal = async (key, customerId, harvestId) => {
    await request(api.createCustomerFocal({ districtId, memberId, customerId, harvestId }))
    const newCustomerList = customersList.map((customer) => {
      if (customer.key === key) {
        return {
          ...customer,
          focalMemberId: memberId,
          focalDistrictId: districtId,
          focalHarvestId: harvestId
        }
      }

      return customer
    })
    setState({
      ...state,
      customerList: newCustomerList
    })
  }

  const deleteCustomerFocal = async (key, customerId, harvestId) => {
    await request(api.deleteCustomerFocal({ districtId, memberId, customerId, harvestId }))
    const newCustomerList = customersList.map((customer) => {
      if (customer.key === key) {
        return {
          ...customer,
          focalMemberId: null,
          focalDistrictId: null,
          focalHarvestId: null
        }
      }

      return customer
    })
    setState({
      ...state,
      customerList: newCustomerList
    })
  }

  const isFocalBodyTemplate = ({ key, focalDistrictId, focalMemberId, focalHarvestId, customerId, harvestId }) => {
    const isFocal = (value, focalValue) => parseInt(value, 10) === parseInt(focalValue, 10)
    const checked =
      isFocal(memberId, focalMemberId) && isFocal(districtId, focalDistrictId) && isFocal(harvestId, focalHarvestId)

    return (
      <Switch
        checked={checked}
        onChange={(checked) =>
          checked ? updateCustomerFocal(key, customerId, harvestId) : deleteCustomerFocal(key, customerId, harvestId)
        }
      />
    )
  }

  const columns = [
    {
      header: getMessage('customer'),
      field: 'customer',
      filterField: 'customer',
      responsive: true
    },
    {
      header: getMessage('location'),
      field: 'location',
      filterField: 'location',
      responsive: true
    },
    {
      header: getMessage('category'),
      field: 'category',
      filterField: 'category',
      responsive: true
    },
    {
      header: getMessage('areaTotal'),
      field: 'areaTotal',
      filterField: 'areaTotal',
      responsive: true,
      body: ({ areaTotal }) => {
        const formattedValue = areaTotal != null ? parseFloat(areaTotal).toLocaleString('pt-BR') + ' ha' : '0 ha'

        return <p style={{ textAlign: 'center', margin: 0 }}>{formattedValue}</p>
      }
    },
    {
      header: 'Focal',
      field: 'focalMemberId',
      body: isFocalBodyTemplate,
      width: '5rem',
      responsive: true
    },
    {
      header: 'Editar',
      body: editBodyTemplate,
      width: '5rem',
      responsive: true
    }
  ]

  return (
    <DataTable ref={ref} itemsList={customersList} filters={filters} columns={columns} emptyMessage="emptyCustomer" />
  )
}

export default List
